import { render, staticRenderFns } from "./InventoryTransferSettings.vue?vue&type=template&id=b29d18fe&scoped=true"
import script from "./InventoryTransferSettings.vue?vue&type=script&lang=ts"
export * from "./InventoryTransferSettings.vue?vue&type=script&lang=ts"
import style0 from "./InventoryTransferSettings.vue?vue&type=style&index=0&id=b29d18fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29d18fe",
  null
  
)

export default component.exports